import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRefresh = () => {
  return (
    <g>
      <path d="M1.75 7.25A.75.75 0 0 1 2.5 8a5.5 5.5 0 0 0 9.937 3.251l-1.187-.001a.75.75 0 1 1 0-1.5h2.95a.8.8 0 0 1 .8.8v2.95a.75.75 0 1 1-1.5 0l.001-1.17A7 7 0 0 1 1 8a.75.75 0 0 1 .75-.75zM8 1a7 7 0 0 1 7 7 .75.75 0 1 1-1.5 0 5.5 5.5 0 0 0-9.938-3.25H4.75a.75.75 0 0 1 0 1.5H1.8a.8.8 0 0 1-.8-.8V2.5a.75.75 0 0 1 1.5 0v1.169A6.996 6.996 0 0 1 8 1z" />
    </g>
  );
};

export default withIcon(IconArrowRefresh);
